import { render, staticRenderFns } from "./teamApplication.vue?vue&type=template&id=20adbff8&scoped=true&"
import script from "./teamApplication.vue?vue&type=script&lang=js&"
export * from "./teamApplication.vue?vue&type=script&lang=js&"
import style0 from "./teamApplication.vue?vue&type=style&index=0&id=20adbff8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20adbff8",
  null
  
)

export default component.exports